var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tag',{attrs:{"color":"viridian-light","fa-icon":"circle-check fat"}},[_vm._v("\n  Offer declined\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }